import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState, MouseEvent } from "react";
import { requestStatusProps } from "../../../../utils/types";
import { api, getToken } from "../../../../services/apis/auth-api/apiUrl";
import { AxiosError } from "axios";


interface UpdateProps {
    inputName : string,
    id: number,
    onSubmit : (stat : requestStatusProps) => void;
    endpoint : string
}

const UpdateButton : React.FC<UpdateProps> = ({inputName, id, onSubmit, endpoint}) => {

    const [loading, setLoading] = useState<boolean>(false);

    function updateDomain (e : MouseEvent<HTMLButtonElement>) {
        e.preventDefault();
        if(inputName === '') return onSubmit({success : false, message : 'Please insert domain name.'})
        setLoading(true);
        setTimeout(async()=>{
            try{
                await api.put(endpoint+id, {
                    name : inputName
                },{
                    headers : {'Authorization' : 'Bearer '+getToken()}
                })
                setLoading(false);
                onSubmit({
                    success : true,
                    message : 'Domain updated!'
                })
            }catch(e){
                const error = (e as AxiosError);
                if(error.response?.status === 401){
                    onSubmit({
                        success : false,
                        message : 'Unauthorized access!'
                    })
                }else{
                    onSubmit({
                        success : false,
                        message : 'An error occured!'
                    })
                }
                setLoading(false);
            }
        },500);
    }

    return (
        <div className="input-container">
            {loading ? (
                <button type="button" disabled className='button button-disabled'>
                    <FontAwesomeIcon className='animate-spin' icon={faSpinner} />  Processing....
                </button>
            ) : (
                <button type="button" onClick={updateDomain} className="button button-vcc-primary text-md">
                    Update
                </button>
            )}
        </div>
    );
}

export default UpdateButton;